import { Avatar, type AvatarProps, Box, Paper } from '@mui/material';
import { amber, cyan, deepOrange, lime, pink, purple } from '@mui/material/colors';
import type { FC } from 'react';
import type { Lab } from 'types/models';

export type Props = {
  size: number;
  sx?: AvatarProps['sx'];
  lab: Pick<Lab, 'name' | 'logo_url'> | null;
};

const colors = [pink, deepOrange, lime, cyan, purple, amber];

const LabAvatar: FC<Props> = ({ size, lab, sx }) => {
  const labName = lab?.name || '?';
  const firstLetter = labName.charAt(0).toUpperCase();
  const color = colors[firstLetter.charCodeAt(0) % colors.length];

  return (
    <Box position="relative" sx={sx}>
      <Paper elevation={2} sx={{ borderRadius: '100%', display: 'inline-flex' }}>
        <Avatar
          sx={{ color: color[900], bgcolor: color[100], width: size, height: size }}
          src={lab?.logo_url || undefined}
          alt={labName}
        >
          {firstLetter}
        </Avatar>
      </Paper>
    </Box>
  );
};

export default LabAvatar;
